import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createTheme, ThemeProvider } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import AuthProvider from "auth/AuthProvider";
import ToastHost from "components/Toast/ToastHost";
import { PageTitleProvider } from "context/PageTitleContext";
import { StudentProvider } from "context/StudentContext";
import App from "./App.jsx";

import { themeMUI } from "styles/themeMUI.js";
import "styles/index.css";

const root = createRoot(document.getElementById("root"));

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

root.render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={createTheme(themeMUI)}>
                <AuthProvider>
                    <PageTitleProvider>
                        <StudentProvider>
                            <App />
                            <ToastHost />
                        </StudentProvider>
                    </PageTitleProvider>
                </AuthProvider>
            </ThemeProvider>
        </QueryClientProvider>
    </StrictMode>,
);
